import Devices from '../../../components/vehicle/devices'
import DeviceStore from '../../../components/vehicle/devices/context/context'

const DevicePage = () => {
  return (
    <DeviceStore>
      <Devices />
    </DeviceStore>
  )
}

export default DevicePage
